"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = require("@jsluna/button");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Step = function Step(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      stepIndex = _ref.stepIndex,
      nextStep = _ref.nextStep,
      lastStepIndex = _ref.lastStepIndex,
      skipTutorial = _ref.skipTutorial,
      previousStep = _ref.previousStep,
      notSkippable = _ref.notSkippable;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "u-tutorial-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "u-tutorial-image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: "view-activities",
    className: "u-tutorial-image-container-image"
  }), stepIndex < lastStepIndex && !notSkippable && /*#__PURE__*/_react.default.createElement(_button.LinkButton, {
    className: "ln-u-margin-right*2 ln-u-margin-top right-button",
    onClick: skipTutorial
  }, "Skip")), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-tutorial-content-container"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "ln-u-text-align-center"
  }, title), /*#__PURE__*/_react.default.createElement("div", null, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "u-tutorial-content-container-buttons"
  }, stepIndex > 0 ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    className: "u-tutorial-content-container-step-button",
    onClick: previousStep
  }, "Previous"), /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    className: "u-tutorial-content-container-step-button right-button",
    onClick: nextStep
  }, stepIndex === lastStepIndex ? 'Get started' : 'Next')) : /*#__PURE__*/_react.default.createElement(_button.FilledButton, {
    fullWidth: true,
    onClick: nextStep
  }, "What's new"))));
};

Step.propTypes = {
  /** The title of the tutorial step */
  title: _propTypes.default.string,

  /** The description of the tutorial step */
  description: _propTypes.default.string,

  /** The image which appears in the tutorial step */
  image: _propTypes.default.string,

  /** The step index of the tutorial step */
  stepIndex: _propTypes.default.number,

  /** The function to be called when next is pressed */
  nextStep: _propTypes.default.func,

  /** The index of the last step of the tutorial */
  lastStepIndex: _propTypes.default.number,

  /** The function to be called when skip is pressed */
  skipTutorial: _propTypes.default.func,

  /** The function to be called when previous button is pressed */
  previousStep: _propTypes.default.func,

  /** Indicates whether the steps of the tutorial can be skipped or not */
  notSkippable: _propTypes.default.bool
};
Step.defaultProps = {
  title: '',
  description: '',
  image: '',
  stepIndex: 0,
  nextStep: function nextStep() {},
  lastStepIndex: 1,
  skipTutorial: function skipTutorial() {},
  previousStep: null,
  notSkippable: false
};
var _default = Step;
exports.default = _default;